import Vue from 'vue'
import { $vfm, vfmPlugin } from 'vue-final-modal/lib'

Vue.use(vfmPlugin)

export default (context, inject) => {
    inject('vfm', $vfm)
}
